import { getPartnerBgColor, getPartnerImage } from "@/app/utils/partners";
import { PartnerType } from "@/app/utils/partners.enum";
import { CreditPartner } from "../../../useCreditController";
import { useSelfHiringContext } from "@/app/contexts/SelfHiringContext";
import { useFormContext } from "react-hook-form";
import { useSelectType } from "./useSelectType";
import { useAuthorizationContent } from "../../AuthorizationModal/authorizationContent";
import { AuthorizationStepsModal } from "../../AuthorizationModal/AutorizationStepsModal";
import { AuthorizationModal } from "../../AuthorizationModal";
import { PartnerCard } from "../partnerCard";
import { ErrorModal } from "../../ErrorModal";
import { ModalSimulatePan } from "@/view/pages/Dashboard/components/TransactionTable/components/TransactionDetails/components/SimulatePanModal";
import { useParams } from "react-router-dom";

interface SelectTypeProps {
  partners?: CreditPartner[];
}
export const SelectType = ({ partners }: SelectTypeProps) => {
  const { linkName } = useParams();
  const methods = useFormContext();
  const { type, setPanData, setStep2mode } = useSelfHiringContext();

  const {
    options,
    linkPan,
    transaction,
    authorizationContentType,
    isAuthorizationOpen,
    isAuthorizationStepsOpen,
    advanceFromAuthorizationModal,
    handleAuthorization,
    handleStepsAuthorizationOpenChange,
    isErrorOpen,
    setIsErrorOpen,
    verifyAuthorization,
    isLoading,
    simulatePanOpen,
    setSimulatePanOpen,
  } = useSelectType(methods, partners || []);

  const authContentKey = authorizationContentType || (type as string);
  const { content } = useAuthorizationContent(authContentKey, linkPan);

  return (
    <>
      <div className="mt-2 flex w-full flex-wrap justify-center gap-4">
        {options?.map((option) => {
          const imageSrc = getPartnerImage(option.type);
          const bgColor = getPartnerBgColor(option.type as PartnerType);
          const isAnyLoading = Object.values(isLoading).some(Boolean);
          return (
            <PartnerCard
              key={option.type}
              title={option.title}
              bgColor={bgColor}
              imageSrc={imageSrc}
              description={option.description}
              needAuthorization={option.needAuthorization}
              submit={option.submit || (() => {})}
              type={option.type}
              disabledButton={isAnyLoading}
              isLoading={!!isLoading[option.type as keyof typeof isLoading]}
            />
          );
        })}
      </div>
      <ModalSimulatePan
        selfHireSimulate={(state) => {
          setPanData({ state });
          setStep2mode("installments");
        }}
        open={simulatePanOpen}
        onOpenChange={setSimulatePanOpen}
        transactionId={transaction?._id}
        customerId={transaction?.customer?._id}
        linkName={linkName}
      />

      {!!(authContentKey && content?.steps?.length) && (
        <AuthorizationStepsModal
          verifyAuthorization={verifyAuthorization}
          key={String(authContentKey)}
          steps={content.steps!}
          isOpen={isAuthorizationStepsOpen}
          onOpenChange={handleStepsAuthorizationOpenChange}
        />
      )}
      <AuthorizationModal
        onVerifyAuthorization={() => verifyAuthorization(type as any)}
        key={authContentKey ? `intro-${authContentKey}` : "intro"}
        onAdvance={advanceFromAuthorizationModal}
        isOpen={isAuthorizationOpen}
        onOpenChange={handleAuthorization}
        title={content?.title ?? ""}
        description={content?.description ?? ""}
      />

      <ErrorModal isOpen={isErrorOpen} onOpenChange={setIsErrorOpen} />
    </>
  );
};
